import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { api } from "../../lib/api";
import { PageHeader, Card, Table, Td, Badge, Empty } from "../../components/UI";
import { ClinicalTabs, TYPE_LABELS, useClients } from "./shared";
import { FSelect } from "../engagement/FormControls";
import { FileText, ClipboardList, FileSignature, ListChecks } from "lucide-react";

const TYPE_ICONS = { progress_note: FileText, treatment_plan: ClipboardList, consent: FileSignature, assessment: ListChecks };
const TYPE_ROUTES = {
  progress_note: (d) => `/clinical/progress-notes/${d.id}`,
  treatment_plan: (d) => `/clinical/treatment-plans/${d.id}`,
  consent: () => "/clinical/consents",
  assessment: (d) => `/clinical/assessments/${d.id}`,
};

export default function AllDocuments() {
  const navigate = useNavigate();
  const clients = useClients();
  const [docs, setDocs] = useState([]);
  const [clientFilter, setClientFilter] = useState("");
  const [typeFilter, setTypeFilter] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const params = {};
    if (clientFilter) params.client_id = clientFilter;
    if (typeFilter) params.doc_type = typeFilter;
    api.get("/clinical-documents", { params }).then((r) => { setDocs(r.data); setLoading(false); });
  }, [clientFilter, typeFilter]);

  return (
    <div>
      <PageHeader title="Complete Chart" subtitle="All progress notes, treatment plans, consents, and assessments in one place" />
      <ClinicalTabs />
      <Card>
        <div className="flex flex-wrap gap-3 p-4">
          <FSelect data-testid="alldocs-client-filter" className="w-56" placeholder="All Clients" value={clientFilter} onChange={(e) => setClientFilter(e.target.value)}>
            {clients.map((c) => <option key={c.id} value={c.id}>{c.first_name} {c.last_name}</option>)}
          </FSelect>
          <FSelect data-testid="alldocs-type-filter" className="w-52" placeholder="All Types" value={typeFilter} onChange={(e) => setTypeFilter(e.target.value)}>
            {Object.entries(TYPE_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
          </FSelect>
        </div>
        <Table headers={["Type", "Title", "Client", "Date", "Status"]}>
          {docs.map((d) => {
            const Icon = TYPE_ICONS[d.type];
            return (
              <tr key={`${d.type}-${d.id}`} data-testid={`doc-row-${d.id}`} onClick={() => navigate(TYPE_ROUTES[d.type](d))}
                className="cursor-pointer hover:bg-[#FDFCF8] transition-colors">
                <Td><span className="inline-flex items-center gap-2 text-[#6D4C41]"><Icon size={14} className="text-[#7B6157]" /> {TYPE_LABELS[d.type]}</span></Td>
                <Td className="font-medium text-[#3E2723]">{d.title}</Td>
                <Td>{d.client_name}</Td>
                <Td>{d.date ? dayjs(d.date).format("MM/DD/YYYY") : "-"}</Td>
                <Td><Badge value={d.status} /></Td>
              </tr>
            );
          })}
        </Table>
        {!loading && docs.length === 0 && <Empty text="No clinical documents match the filters" />}
      </Card>
    </div>
  );
}
